import { createClient } from '@supabase/supabase-js'

const supabaseUrl     = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// ── Debug: log exactly what values the client is picking up ──────────────────
// Check the browser console (F12 → Console) after loading the app.
// Remove these lines once the issue is resolved.
console.log('[supabase.js] REACT_APP_SUPABASE_URL     =', supabaseUrl     ?? 'UNDEFINED')
console.log('[supabase.js] REACT_APP_SUPABASE_ANON_KEY=', supabaseAnonKey ? `${supabaseAnonKey.slice(0, 20)}…` : 'UNDEFINED')
console.log('[supabase.js] All REACT_APP_ env vars available:', Object.keys(process.env).filter(k => k.startsWith('REACT_APP_')))

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. ' +
    'REACT_APP_SUPABASE_URL: ' + (supabaseUrl ?? 'undefined') + ', ' +
    'REACT_APP_SUPABASE_ANON_KEY: ' + (supabaseAnonKey ? 'present' : 'undefined')
  )
}

// ── Clear any corrupted session tokens from localStorage ──────────────────────
// Prevents "Invalid API key" from a malformed token persisted by an earlier
// version of this app. Only touches keys belonging to this Supabase project.
try {
  const projectId  = supabaseUrl.match(/https?:\/\/([^.]+)\./)?.[1] ?? ''
  const storageKey = `sb-${projectId}-auth-token`
  const raw        = localStorage.getItem(storageKey)
  if (raw) {
    const parsed = JSON.parse(raw)
    if (!parsed?.access_token || !parsed?.refresh_token) {
      console.warn('[supabase.js] Removing corrupt session token from localStorage:', storageKey)
      localStorage.removeItem(storageKey)
    }
  }
} catch (e) {
  console.warn('[supabase.js] localStorage cleanup failed (non-fatal):', e)
}

// flowType: 'implicit' forces the token into the URL hash fragment
// (#access_token=...&type=recovery) rather than PKCE query params (?code=...).
// PKCE is more secure but our hash-detection approach requires implicit flow.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken:   true,
    persistSession:     true,
    detectSessionInUrl: true,
    flowType:           'implicit',
  }
})
